import { useShoppingCart, useSideCart } from '@hooks/cart/useShoppingCart';
import SadCart from '@monofront/design-system/visuals/Icons/Old/SadCart';
import Button from '@monofront/design-system/components/Button';
import Modal from '@monofront/design-system/organisms/Modal';
import logger from '@utils/logger';
import { useTranslations } from 'next-intl';
import { toast } from 'react-toastify';

interface IModalFreshProductsProps {
  isOpen: boolean;
  onClose: () => void;
}

const ModalFreshProducts: React.FC<IModalFreshProductsProps> = ({
  isOpen,
  onClose,
}) => {
  const {
    deleteFreshAndUltraFreshProductsFromCart,
    shoppingCart,
    shoppingCartId,
  } = useShoppingCart();
  const { dispatchSideCart } = useSideCart();
  const tGlobal = useTranslations('Global');
  const tFresh = useTranslations('Fresh');

  const onClickRemoveProducts = async () => {
    try {
      if (!shoppingCartId) {
        throw new Error('Unexpected empty `shoppingCartId`');
      }

      dispatchSideCart({ type: 'viewMyCart' });
      onClose();
      await deleteFreshAndUltraFreshProductsFromCart(
        shoppingCartId,
        shoppingCart.products,
      );
    } catch (e: unknown) {
      logger.error('Failed to remove fresh products from cart', e);
      toast(tGlobal('errorOccurredTryAgain'), {
        progressClassName: 'toast-error',
      });
    }
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        externalToggle={onClose}
        UNSAFE_className="modal-delete-fresh-products"
        hasPadding
      >
        <SadCart />
        <h2 className="h6 title">{tFresh('deleteFreshProductsTitle')}</h2>
        <p>{tFresh('deleteFreshProductsDesc')}</p>

        <div className="modal-cta">
          <Button variant="secondary" hasMinWidth={false} onClick={onClose}>
            {tGlobal('cancel')}
          </Button>
          <Button hasMinWidth={false} onClick={onClickRemoveProducts}>
            {tFresh('deleteFreshProductsCTA')}
          </Button>
        </div>
      </Modal>
      <style jsx>{`
        :global(.modal-delete-fresh-products) {
          top: 33%;
          max-width: 560px;
          text-align: center;
        }

        .modal-cta {
          margin-top: var(--space-5);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .modal-cta > :global(button) {
          width: fit-content;
        }

        .modal-cta > :global(button:first-child) {
          margin-right: var(--space-3);
        }

        .title {
          margin-bottom: var(--space-2);
        }
      `}</style>
    </>
  );
};

export default ModalFreshProducts;
